// Mismas clases que pages/CrmContacts.tsx, para los componentes de la ficha del lead.
export const inputClass = 'w-full rounded-lg border-gray-300 shadow-sm text-sm focus:ring-vida-500 focus:border-vida-500';
export const labelClass = 'block text-sm font-medium text-gray-700 mb-1';
export const cardClass = 'bg-white rounded-lg border border-gray-200 shadow-sm';

// Páginas públicas del lead (texto algo mayor, sin `text-sm` en los campos).
export const leadInputClass = 'w-full rounded-lg border-gray-300 shadow-sm focus:ring-vida-600 focus:border-vida-600';
export const leadLabelClass = 'block text-sm font-medium text-gray-800 mb-1';
